import styled from '@emotion/styled'
import { BREAKPOINTS } from 'utils/styled'

export const SCardWrapper = styled.div`
  background: var(--c-gray300);
  padding: 1.5rem;
  margin: 1.5rem 1rem 0;
  @media ${BREAKPOINTS.MD.min} {
    margin: 0;
  }
`
